<script>
import { jpShortDateString, getListViewUrl } from '../common/common';
import { JPDateRangeString, addMonthToDate, addDaysToDate, goDateString } from '../js/common'
import SummaryDateNavButtons from '../view/components/summaryDateNav/SummaryDateNavButtons.vue';

export default {
  props: {
    activeCompanyID: Number,
    startDate: Date,
    endDate: Date,
    timePeriodType: String,
    currentPage: String,
    showDailyButton: {
      type: Boolean,
      default: false,
    },
    page: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDropdown: false,
    }
  },
  data() {
    return {
      showDropdown: false,
    }
  },
  methods: {
    handleShowDropdown() {
      this.showDropdown = true;
    },
    handleDropdownBlur(evt) {
      const next = evt?.relatedTarget || document.activeElement;
      if (this.$el && next && this.$el.contains(next)) {
        return;
      }
      this.showDropdown = false;
    },
    changeListDatesUrl(newDate) {
      const param = getSearchParam();

      param.list = this.timePeriodType;
      param.date = newDate;

      const url = window.location.origin + window.location.pathname;
      return `${url}?${$.param(param)}`;
    },
    getPreviousDate() {
      if (this.timePeriodType === "month") {
        const startOfMonth = this.startDate.getUTCDate();
        return addMonthToDate(this.startDate, -1, startOfMonth);
      }
      else if (this.timePeriodType === "week") {
        return addDaysToDate(this.startDate, -7);
      }
      // Custom is used for Daily so we only add/subtract 1
      else if (this.isCustomView) {
        return addDaysToDate(this.startDate, -1);
      }
    },
    getNextDate() {
      if (this.timePeriodType === "month") {
        const startOfMonth = this.startDate.getUTCDate();
        return addMonthToDate(this.startDate, 1, startOfMonth);
      }
      else if (this.timePeriodType === "week") {
        return addDaysToDate(this.startDate, 7);
      }
      // Custom is used for Daily so we only add/subtract 1
      else if (this.isCustomView) {
        return addDaysToDate(this.startDate, 1);
      }
    },
    goToCurrentDate() {
      const today = GetToday();
      const param = {
        c: this.activeCompanyID,
        list: GetURLParam("list"),
        tags:  GetURLParam("tags"),
        date: today,
      };
      param = pushURLParmToParmObj(param, paramToPass);

      // Clicking "today" if you are in calendar tab should return url with: &date=(today)&until=(today + day difference)
      // getDaysDiff function to calculate the difference (or the date range) of days depending on the dates user selected.
      // addDays function to add the difference of days to current date to get the range of dates from today.
      const until = GetURLParam("until");
      if (until != "") {
        const date = GetURLParam("date");
        const daysDiff = getDaysDiff(until, date);
        const addedDays = addDays(today, daysDiff);

        param["until"] = addedDays;
      }

      const url = window.location.origin + window.location.pathname;
      window.location = url + "?" + $.param(param);
    },
    getPreviousDateUrl() {
      const prevDate = goDateString(this.getPreviousDate());
      if (this.isCustomView) {
        return this.getListDayUrl(prevDate);
      }
      return this.changeListDatesUrl(prevDate);
    },
    getNextDateUrl() {
      const nextDate = goDateString(this.getNextDate());
      if (this.isCustomView) {
        return this.getListDayUrl(nextDate);
      }
      return this.changeListDatesUrl(nextDate);
    },
    // From dashboard_base.html since these are specifically used in date nav, we move these functions here.
    // Once the refactor are done and all date-nav in the codebase are changed to Vue component, we should remove the same functions from dashboard_base
    listWeek() {
      const date = GetURLParam("date") || GetToday();
      const params = this.getParams();
      return getListViewUrl(date, this.activeCompanyID?.toString(), "week", undefined, params);
    },
    listMonth() {
      const date = GetURLParam("date") || GetToday();
      const params = this.getParams();
      return getListViewUrl(date, this.activeCompanyID?.toString(), "month", undefined, params);
    },
    getListDayUrl(startDate) {
      const today = GetToday();
      let date = startDate || today;
      if (!startDate && this.isSummaryPage) {
        date = GetURLParam("date") || today;
      }
      const type = (this.page === "plan" || this.isSummaryPage) ? "day" : "custom";
      return getListViewUrl(date, this.activeCompanyID?.toString(), type, date);
    },
    // getParams will keep the passed param values alive across page loads.
    // We might want to pass more params in the future if we want to render tags or other filters.
    getParams() {
      // comqr param indicates that the user was redirected to the company user timecard page via a company QR punch. We need to keep the param to properly generate DOM.
      return ["comqr"];
    },
    openFilterModal() {
      this.$emit("open-tag-role-filter-modal");
    }
  },
  computed: {
    isCustomView() {
      return this.timePeriodType === "custom" || this.timePeriodType === "day";
    },
    isWeeklyView() {
      return this.timePeriodType === "week";
    },
    isMonthlyView() {
      return this.timePeriodType === "month";
    },
    isSummaryCustomView() {
      return this.isSummaryPage && this.timePeriodType === "custom";
    },
    isSummaryPage() {
      return this.currentPage === "summary";
    },
    isTimecardPage() {
      return this.currentPage === "timecard";
    },
    activeDayBtn() {
      return this.isCustomView ? "active" : '';
    },
    activeWeekBtn() {
      return this.isWeeklyView ? "active" : '';
    },
    activeMonthBtn() {
      return this.isMonthlyView ? "active" : '';
    },
    renderDateRange() {
      if (this.isCustomView && !this.isSummaryCustomView) {
        return jpShortDateString(this.startDate);
      }
      return JPDateRangeString(this.startDate, this.endDate);
    },
    renderYearDate() {
      return `${new Date(this.startDate).getUTCFullYear()}年`
    },
    selectedTimePeriodType() {
      let text = "週"

      if (this.isMonthlyView) {
        text = '月'
      }

      if (this.isCustomView) {
        text = '日'
      }

      return text;
    },
    dateRangeClass() {
      return {
        'hide-sm': this.isSummaryPage,
        'hide-xs': this.isTimecardPage,
        'date-range-center': this.isTimecardPage, // Center the date label to align with clock-in/out buttons
      }
    },
    mobileDateRangeClass() {
      return {
        'show-xs': this.isTimecardPage,
      }
    },
  },
  components: {
    SummaryDateNavButtons,
  },
}


</script>
<template>
  <div class="date-nav-wrapper">
    <div class="date-range date-range-center mobile-date-range" :class="mobileDateRangeClass">
      <span class="date-range-label">{{ renderDateRange }}</span>
    </div>

    <div class="date-arrow-buttons">
      <a class="date-range" :href="getPreviousDateUrl()">
        <i class="icon icon-arrow-left nav-button"></i>
      </a>
      <span class="nav-button today" onclick="todayClicked()">今日</span>
      <a class="date-range" :href="getNextDateUrl()">
        <i class="icon icon-arrow-right nav-button"></i>
      </a>
    </div>

    <div class="date-range" :class="dateRangeClass">
      <small class="date-year-label">{{ renderYearDate }}</small>
      <span class="date-range-label">{{ renderDateRange }}</span>
    </div>

    <div class="align-center">
      <div v-if="isSummaryPage">
        <SummaryDateNavButtons
          @open-filter-modal="openFilterModal"
        />
      </div>

      <div class="list-date-wrapper hide-sm" :class="{ 'd-none': isSummaryPage }">
        <a v-if="showDailyButton" :class="activeDayBtn" class="nav-button date-list-btn" :href="getListDayUrl()">
          <span>日</span>
        </a>
        <a :class="activeWeekBtn" class="nav-button date-list-btn" :href="listWeek()">
          <span>週</span>
        </a>
        <a :class="activeMonthBtn" class="nav-button date-list-btn" :href="listMonth()">
          <span>月</span>
        </a>
      </div>

      <div class="list-date-mobile-wrapper" :class="{ 'show-sm': !isSummaryPage }" @click="handleShowDropdown()" @focusout="handleDropdownBlur" tabindex="1">
        <div class="nav-button active date-list-btn mobile">
          <div class="list-date-mobile-text">
            <span class="date-nav-text">
              <div v-if="isSummaryCustomView"><i class="zmdi zmdi-calendar-note"></i></div>
              <div v-else>{{ selectedTimePeriodType }}</div>
            </span>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve" viewBox="0 0 85 85" class="date-nav-icon">
              <path fill="currentColor" d="M58.7,34.3c2.1,0,2.6,1.2,1.1,2.7l-13,13c-1.5,1.5-4,1.5-5.5,0l-13-13c-1.5-1.5-1-2.7,1.1-2.7H58.7z"/>
            </svg>
          </div>
        </div>
        <div v-show="showDropdown" class="date-nav-dropdown">
          <div class="date-nav-dropdown-wrapper">
            <a v-if="showDailyButton" class="date-nav-dropdown-item" :href="getListDayUrl()">日</a>
            <a class="date-nav-dropdown-item" :href="listWeek()">週</a>
            <a class="date-nav-dropdown-item" :href="listMonth()">月</a>
            <a v-if="isSummaryPage" class="date-nav-dropdown-item" id="calendar-btn-dropdown">
              <i class="zmdi zmdi-calendar-note" style="font-size: 18px;"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .date-nav-wrapper {
    margin: 15px 0;
    position: relative;
  }

  .date-nav-wrapper,
  .list-date-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    gap: 5px;
  }

  .date-range {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: large;
    color: #5F6B71;;
  }

  .date-range-center {
    position: absolute;
    left: 50%;
    transform: translateX(-48%);
  }

  .mobile-date-range {
    display: none;
    margin-bottom: 63px;
  }

  .date-arrow-buttons {
    width: fit-content;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 0.02rem solid #E9EBEC;
    border-radius: 50px;
    padding: 0 20px;
    height: 36px;
    gap: 22px
  }

  .icon-arrow-left::before,
  .icon-arrow-right::before {
    border: 0.05rem solid currentColor;
    border-bottom: 0;
    border-right: 0;
  }

  .icon-arrow-left:hover::before,
  .icon-arrow-right:hover::before {
    border-width: 0.1rem;
  }

  .icon.nav-button:hover, .today:hover {
    font-weight: 600;
  }

  .date-list-btn {
    height: 36px;
    width: 36px;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .date-list-btn:hover {
    background-color: #52a3d5;
    color: #fff;
    border-radius: 50px;
  }

  .date-list-btn.mobile {
    height: 36px;
    width: 36px;
  }

  .nav-button {
    font-size: 0.8rem;
    cursor: pointer;
    color: #5F6B71;
  }

  .nav-button.active {
    background-color: #52a3d5;
    color: #fff;
    border-radius: 50px;
    text-decoration: none;
  }

  .date-year-label {
    line-height: 0.7rem;
    font-size: 0.7rem;
  }

  .date-range-label {
    font-size: 1rem;
    line-height: 1.2rem;
  }
  
  .mobile-date-range .date-range-label {
    font-size: .7rem;
  }

  @media (max-width: 400px) {
    .date-range-label {
      font-size: .7rem;
    }
  }

  .list-date-mobile-wrapper {
    position: relative;
  }

  .date-nav-dropdown-item {
    width: 100%;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: .2s ease;
  }

  .date-nav-dropdown-item:not(:last-child) {
    border-bottom: 0.02rem solid #a5a5a5;
  }

  .date-nav-dropdown-item:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .date-nav-dropdown-item:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .date-nav-dropdown-item:hover,
  .date-nav-dropdown-item.active {
    background-color: #52a3d5;
    color: #fff;
  }

  .date-nav-dropdown {
    border-radius: 5px;
    background-color: #fff;
    color: #5F6B71;
    width: 51px;
    position: absolute;
    right: 0;
    top: 50px;
    box-shadow: 0px 1px 4px 1px #8e8e8e91;
    z-index: 5;
    animation: slide-down .2s ease 1;
  }

  .date-nav-dropdown-wrapper {
    display: flex;
    border-radius: 5px;
    flex-direction: column;
    align-items: center;
    height: 100%;
  }

  .list-date-mobile-text {
    display: flex;
    flex-direction: column;
  }

  .date-nav-text {
    text-align: center;
    font-size: 16px;
    margin-top: 10px;
  }

  .date-nav-icon {
    width: 25px;
    margin-top: -10px;
  }

  a:hover {
    text-decoration: none;
  }

  a:focus {
    box-shadow: none;
  }

  a {
    color: inherit;
  }

  @keyframes slide-down {
    0% {
        opacity: 0;
        transform: translateY(-1.6rem);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
  }

  @media (max-width: 390px) {
    .date-arrow-buttons {
      padding: 0 13px;
      gap: 13px;
    }
  }
</style>
